// extracted by mini-css-extract-plugin
module.exports = {"notificationsStroke":"_23zYH","notificationsFill":"_3RleN"};